import script from "./PotentialPoliciesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialPoliciesTable.vue?vue&type=script&setup=true&lang=js"

import "./PotentialPoliciesTable.vue?vue&type=style&index=0&id=4802583a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4802583a"]])

export default __exports__